import * as React from "react";
import * as Immutable from "immutable";
import { useState, useEffect, useContext, useMemo } from "react";
import BackendWizardContext from "components/authentication/directoryServices/BackendWizard/BackendWizardContext";
import MatchingGroupsContext from "./MatchingGroupsContext";
import prepareLoadGroupsPayload from "../../logic/directoryServices/prepareLoadGroupsPayload";
import { GroupSyncActions } from "../../stores/directoryServices/GroupSyncStore";
const MatchingGroupsProvider = ({ children, prepareSubmitPayload }) => {
  const { setStepsState, ...stepsState } = useContext(BackendWizardContext);
  const { authBackendMeta, formValues } = stepsState;
  const [contextValue, setContextValue] = useState({ result: void 0, finishedLoading: true });
  const matchingGroupsContextValue = useMemo(() => ({ ...contextValue, setContextValue }), [contextValue]);
  useEffect(() => {
    if (authBackendMeta.backendId && authBackendMeta.backendGroupSyncIsActive) {
      setContextValue({ finishedLoading: false, result: void 0 });
      const payload = prepareLoadGroupsPayload(
        prepareSubmitPayload,
        formValues,
        authBackendMeta.backendId,
        authBackendMeta.serviceType
      );
      GroupSyncActions.loadGroups(payload).then((result) => {
        setContextValue({ finishedLoading: true, result });
      }).catch((error) => {
        setContextValue({ finishedLoading: true, result: { errors: Immutable.List([error]) } });
      });
    }
  }, []);
  return /* @__PURE__ */ React.createElement(MatchingGroupsContext.Provider, { value: matchingGroupsContextValue }, children);
};
export { MatchingGroupsContext };
export default MatchingGroupsProvider;
